import styled from "styled-components";

export const SubMenuTwoCol = styled.div<{
  width?: string;
  alignSelf?: string;
  colGapSpace?: number;
  gridTemplateColumns?: string;
}>`
  display: grid;

  width: ${({ width }) => width ?? "100%"};

  max-width: 100%;

  grid-template-columns:  ${({ gridTemplateColumns }) =>
    gridTemplateColumns ?? "auto 1fr"};

  align-items: start;

  & > :first-child {
    justify-self: start;
    align-self: ${({ alignSelf }) => alignSelf ?? "start"};
  }

  & > :last-child {
    justify-self: end;
    align-self: ${({ alignSelf }) => alignSelf ?? "start"};
  }

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        column-gap: ${props.theme.spacePx(breakpoint, props.colGapSpace ?? 7)};
        min-height: ${props.theme.spacePx(breakpoint, 6)};
        `;
    })}
`;

export default SubMenuTwoCol;
